const isCitifydApp = application => !application || application === 'citifyd'

const getAppRoute = (application, param) => {
  if (param === 'as') return isCitifydApp(application) ? '' : '/[application]'
  if (param === 'url') return isCitifydApp(application) ? '' : `/${application}`
}

export { getAppRoute, isCitifydApp }
